import { useCallback, useContext, useEffect } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { Prompt } from '@sorare/wallet-shared';

import { useOnWalletLoaded } from '#src/contexts/wallet/walletLoaded/index.tsx';
import {
  WalletTab,
  useWalletDrawerContext,
} from '#src/contexts/walletDrawer/index.tsx';
import { useEvents } from '#src/lib/events/useEvents.ts';

export const useOAuthEthWallet = () => {
  const { sendRequest } = useContext(MessagingContext)!;
  const { setCurrentTab, showWallet, hideWallet } = useWalletDrawerContext();
  const track = useEvents();
  const subscribeOnWalletLoaded = useOnWalletLoaded();

  const promptGenerateKeys = useCallback(async () => {
    setCurrentTab(WalletTab.GENERATE_KEYS);
    showWallet();
    track('View Set Wallet Password');
    await sendRequest<Prompt>('prompt', {
      type: 'generateKeys',
    });
  }, [sendRequest, setCurrentTab, showWallet, track]);

  useEffect(
    () =>
      subscribeOnWalletLoaded(() => {
        setCurrentTab(WalletTab.HOME);
        hideWallet();
      }),
    [subscribeOnWalletLoaded, setCurrentTab, hideWallet]
  );

  return {
    promptGenerateKeys,
  };
};
